import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { LoginService } from "../services/login.service";
import { LoginChangePasswordRequest } from "./ChangePasswordRequest";
import * as shajs from "sha.js";

@Component({
	selector: "app-password-reset-by-admin",
	templateUrl: "./password-reset-by-admin.component.html",
	styleUrls: ["./password-reset-by-admin.component.css"],
})
export class PasswordResetByAdminComponent implements OnInit {
	constructor(
		private loginService: LoginService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.loginInfo = this.dialogConfig.data.loginInfo;
		this.TempToken2 = this.dialogConfig.data.TempToken2;

		this.UserName = this.loginInfo.userName;

		this.loadSecurityPrefs();
		this.loadPasswordInstructions();
	}

	//////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////
	loginInfo: any;
	TempToken2: any;

	UserName: any = "";
	NewPassword: any = "";
	ConfirmPassword: any = "";

	errorMessage: any = "";

	//
	// Security Prefs
	//
	PasswordUpdating: any = false;
	LoadingPrefs: any = false;

	PasswordExpID: any = 0;
	PasswordReuseID: any = 0;
	MinLength: any = "3";
	ContainNumbers: any = false;
	ContainSpecialChars: any = false;
	ChangeAfterAdminReset: any = false;
	LockoutAttemptsID: any = 0;
	PasswordInstructions: string = "";

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////
	loadSecurityPrefs() {
		//
		// Based on District Admin/Security Settings
		//
		this.LoadingPrefs = true;

		var result = this.loginService.LoadDistrictSecurityPreferenceList();
		result.subscribe(
			(response) => {
				var prefs: any = response;

				for (var i = 0; i < prefs.length; i++) {
					var next = prefs[i];

					if (next.KeyName == "PasswordExpiration") {
						this.PasswordExpID = Number(next.KeyValue);
					} else if (next.KeyName == "PasswordReuse") {
						this.PasswordReuseID = Number(next.KeyValue);
					} else if (next.KeyName == "PasswordLength") {
						this.MinLength = Number(next.KeyValue);
					} else if (next.KeyName == "PasswordNumbers") {
						this.ContainNumbers = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordSpecialChars") {
						this.ContainSpecialChars = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordReset") {
						this.ChangeAfterAdminReset = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordLockoutAttempts") {
						this.LockoutAttemptsID = Number(next.KeyValue);
					}
				}

				this.LoadingPrefs = false;
			},
			(error) => {
				this.LoadingPrefs = false;
			}
		);
	}

	loadPasswordInstructions() {
		var result = this.loginService.PasswordInstructionSelect();
		result.subscribe(
			(response: any) => {
				this.PasswordInstructions = response.str;
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////
	onUpdate() {
		this.PasswordUpdating = true;

		this.errorMessage = "";

		//
		// Error handling
		//

		// Null
		if (this.NewPassword == "") {
			this.errorMessage = "Enter a password";

			this.PasswordUpdating = false;

			return;
		} else if (this.ConfirmPassword == "") {
			this.errorMessage = "Confirm password";

			this.PasswordUpdating = false;

			return;
		} else if (String(this.NewPassword) != String(this.ConfirmPassword)) {
			this.errorMessage = "Passwords don't match";

			this.PasswordUpdating = false;

			return;
		}
		//
		// Check prefs
		//
		else if (this.NewPassword.length < Number(this.MinLength) || this.ConfirmPassword.length < Number(this.MinLength)) {
			this.errorMessage = "Password must be at least " + String(this.MinLength) + " characters";

			this.PasswordUpdating = false;

			return;
		} else if (this.GetNumberCount(String(this.NewPassword)) == 0 && this.ContainNumbers) {
			this.errorMessage = "Password must have at least 1 number";

			this.PasswordUpdating = false;

			return;
		} else if (this.GetSpecialChar(String(this.NewPassword)) == 0 && this.ContainSpecialChars) {
			this.errorMessage = "Password must have at least 1 special character";

			this.PasswordUpdating = false;

			return;
		}

		this.ProcessChangePassword();
		// Don't care if password was already used
	}

	ProcessChangePassword() {
		// console.log("New Password");
		// console.log(this.NewPassword);

		//
		// Create Request
		//
		var PasswordHash = String(shajs("sha256").update(this.NewPassword).digest("hex")).toUpperCase();

		let parms: LoginChangePasswordRequest = {
			UserID: this.loginInfo.userID,
			Password: PasswordHash,
			TempToken2: this.TempToken2,
		};

		//
		// Call SP
		//

		var result = this.loginService.ChangePassword(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//
					// Success dialog
					//
					this.confirmationService.confirm({
						key: "pass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Password was changed successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.FinishPasswordChange();
						},
						reject: () => {
							this.FinishPasswordChange();
						},
					});
				} else {
					this.PasswordUpdating = false;

					//
					// Fail dialog
					//
					this.confirmationService.confirm({
						key: "pass",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error processing reset password request: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							return;
						},
					});
				}
			},
			(error) => {
				this.PasswordUpdating = false;

				return;
			}
		);
	}

	FinishPasswordChange() {
		//
		// Close dialog
		//
		this.ref.close(1);
	}

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////

	GetNumberCount(pass: String) {
		var count = 0;

		for (var i = 0; i < pass.length; i++) {
			var next = pass.substr(i, 1);

			if (!Object.is(Number(next), NaN)) {
				count++;
			}
		}

		return count;
	}

	GetSpecialChar(pass: String) {
		var count = 0;
		var letters = "abcdefghijklmnopqrstuvwxyz";

		for (var i = 0; i < pass.length; i++) {
			var next = pass.substr(i, 1);

			//Not a number and not a letter
			if (Object.is(Number(next), NaN) && letters.indexOf(next.toLowerCase()) == -1) {
				count++;
			}
		}

		return count;
	}

	//////////////////////////////////////////////////////////////////////
}
